export const postShader = {
    vertexShader: /* glsl */`
        attribute vec3 aPosition;
        attribute vec2 aTexCoord;
        varying vec2 vTexCoord;

        void main() {
        vTexCoord = aTexCoord;
        vec4 positionVec4 = vec4(aPosition, 1.0);
        positionVec4.xy = positionVec4.xy * 2.0 - 1.0;
        gl_Position = positionVec4;
        }`
    ,fragmentShader: /* glsl */`
    precision mediump float;

    uniform float time;
    uniform sampler2D tex0;
    uniform vec2 resolution;
    uniform bool gray;

    varying vec2 vTexCoord;

    vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}
    vec2 fade(vec2 t) {return t*t*t*(t*(t*6.0-15.0)+10.0);}
    float cnoise(vec2 P){
        vec4 Pi = floor(P.xyxy) + vec4(0.0, 0.0, 1.0, 1.0);
        vec4 Pf = fract(P.xyxy) - vec4(0.0, 0.0, 1.0, 1.0);
        Pi = mod(Pi, 289.0); // To avoid truncation effects in permutation
        vec4 ix = Pi.xzxz;
        vec4 iy = Pi.yyww;
        vec4 fx = Pf.xzxz;
        vec4 fy = Pf.yyww;
        vec4 i = permute(permute(ix) + iy);
        vec4 gx = 2.0 * fract(i * 0.0243902439) - 1.0; // 1/41 = 0.024...
        vec4 gy = abs(gx) - 0.5;
        vec4 tx = floor(gx + 0.5);
        gx = gx - tx;
        vec2 g00 = vec2(gx.x,gy.x);
        vec2 g10 = vec2(gx.y,gy.y);
        vec2 g01 = vec2(gx.z,gy.z);
        vec2 g11 = vec2(gx.w,gy.w);
        vec4 norm = 1.79284291400159 - 0.85373472095314 * 
            vec4(dot(g00, g00), dot(g01, g01), dot(g10, g10), dot(g11, g11));
        g00 *= norm.x;
        g01 *= norm.y;
        g10 *= norm.z;
        g11 *= norm.w;
        float n00 = dot(g00, vec2(fx.x, fy.x));
        float n10 = dot(g10, vec2(fx.y, fy.y));
        float n01 = dot(g01, vec2(fx.z, fy.z));
        float n11 = dot(g11, vec2(fx.w, fy.w));
        vec2 fade_xy = fade(Pf.xy);
        vec2 n_x = mix(vec2(n00, n01), vec2(n10, n11), fade_xy.x);
        float n_xy = mix(n_x.x, n_x.y, fade_xy.y);
        return 2.3 * n_xy;
    }

    vec4 getTex(sampler2D txtr,vec2 uv){
        uv = fract(uv);
        return texture2D(txtr, uv);
    }

    float getNoise(vec2 uv){
        float val = 0.0;
        val += cnoise(uv * 200.0 + time);
        val += cnoise(uv * 100.0 + time);
        val += cnoise(uv * 50.0 + time);
        val += cnoise(uv * 25.0 + time);
        val += cnoise(uv * 10.0 + time);
        val += cnoise(uv * 5.0 + time);
        val += cnoise(uv * 2.0 + time);
        val += cnoise(uv * 3000.0 + time) * 20.0 - 10.0;
        // val -= cnoise(uv * .3 + time) * cnoise(uv * .3 + time) * 20.0;
        val /= 255.0;
        return val;
    }

    float grayscale(vec4 color){
        return color.r * 0.3 + color.g * 0.59 + color.b * 0.11;
    }

    void main() {
        vec2 uv = vTexCoord;
        uv.y = 1.0 - uv.y;
        
        vec4 tex = getTex(tex0,uv);

        if (gray){
            float grayVal = grayscale(tex);
            // if (grayVal < 0.1) grayVal = 0.1;
            tex = vec4(grayVal,grayVal,grayVal,tex.a);
        }
        
        float noise = getNoise(uv);
        tex = tex + vec4(noise,noise,noise,0.0);
        
        gl_FragColor = tex; 
    }
    `
}


export const revealShader = {
    vertexShader : `
    attribute vec3 aPosition;
    attribute vec2 aTexCoord;
    varying vec2 vTexCoord;

    void main() {
    vTexCoord = aTexCoord;
    vec4 positionVec4 = vec4(aPosition, 1.0);
    positionVec4.xy = positionVec4.xy * 2.0 - 1.0;
    gl_Position = positionVec4;
    }
    `,

    fragmentShader : `
    precision mediump float;

    uniform sampler2D tex0;
    uniform float noiseOffset;
    uniform float exposure;
    varying vec2 vTexCoord;

    vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}
    vec2 fade(vec2 t) {return t*t*t*(t*(t*6.0-15.0)+10.0);}

    float cnoise(vec2 P){
    P = P + noiseOffset;
    vec4 Pi = floor(P.xyxy) + vec4(0.0, 0.0, 1.0, 1.0);
    vec4 Pf = fract(P.xyxy) - vec4(0.0, 0.0, 1.0, 1.0);
    Pi = mod(Pi, 289.0);
    vec4 ix = Pi.xzxz;
    vec4 iy = Pi.yyww;
    vec4 fx = Pf.xzxz;
    vec4 fy = Pf.yyww;
    vec4 i = permute(permute(ix) + iy);
    vec4 gx = 2.0 * fract(i * 0.0243902439) - 1.0;
    vec4 gy = abs(gx) - 0.5;
    vec4 tx = floor(gx + 0.5);
    gx = gx - tx;
    vec2 g00 = vec2(gx.x,gy.x);
    vec2 g10 = vec2(gx.y,gy.y);
    vec2 g01 = vec2(gx.z,gy.z);
    vec2 g11 = vec2(gx.w,gy.w);
    vec4 norm = 1.79284291400159 - 0.85373472095314 * 
        vec4(dot(g00, g00), dot(g01, g01), dot(g10, g10), dot(g11, g11));
    g00 *= norm.x;
    g01 *= norm.y;
    g10 *= norm.z;
    g11 *= norm.w;
    float n00 = dot(g00, vec2(fx.x, fy.x));
    float n10 = dot(g10, vec2(fx.y, fy.y));
    float n01 = dot(g01, vec2(fx.z, fy.z));
    float n11 = dot(g11, vec2(fx.w, fy.w));
    vec2 fade_xy = fade(Pf.xy);
    vec2 n_x = mix(vec2(n00, n01), vec2(n10, n11), fade_xy.x);
    float n_xy = mix(n_x.x, n_x.y, fade_xy.y);
    return 2.3 * n_xy;
    }

    void main() {
        vec2 uv = vTexCoord;
        uv.y = 1.0 - uv.y;
        vec4 origTex = texture2D(tex0,uv);
        float noise = pow(cnoise(uv * 5.0),3.0);
        gl_FragColor = mix(origTex * noise * exposure, origTex, exposure);
    }
`
}